<div class="d-flex flex-column w-100 h-100">
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title page-title">Forms</h4>
            <div class="ws-section__header__actions">
                @if (canEdit) {
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                [disabled]="!selectedState"
                                class="ace-btn btn-sm btn-primary"
                                (click)="createNewForm()"
                                title="Create New Form">
                            New Form
                        </button>
                    </div>
                }
                @if (canExport) {
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary"
                                (click)="exportFormsLibrary()"
                                title="Export Form library">
                            Export Form Library
                        </button>
                    </div>
                }
                @if (canExport) {
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary"
                                (click)="exportFormList()"
                                title="Export Form list">
                            Export Form List
                        </button>
                    </div>
                }
                @if (canExport) {
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary"
                                (click)="exportFormsSetup()"
                                title="Export Forms setup">
                            Export Form Setup
                        </button>
                    </div>
                }
                @if (canEdit) {
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary"
                                (click)="importFormsSetup()"
                                title="Import Forms setup">
                            Import Form Setup
                        </button>
                    </div>
                }
                <div class="ws-section__header__actions__item">
                    <button type="button"
                            class="ace-btn btn-sm btn-secondary has-icon"
                            (click)="refresh()"
                            [disabled]="refreshing"
                            title="Refresh">
                        <i class="fa fa-refresh"></i></button>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex flex-column w-100 h-100">
        <div class="d-flex filter-row">
            <div class="d-flex filter-group align-items-center">
                <label class="ws-flex-auto my-0" for="state">State:</label>
                <div class="ws-flex-auto">
                    <ws-select labelProperty="fullName"
                               [returnEntireOption]="true"
                               placeholder="Nothing selected"
                               [canDeselect]="true"
                               deselectLabel="Nothing selected"
                               [deselectValue]="null"
                               [valueFormatter]="stateFormatter"
                               [(ngModel)]="selectedState"
                               (ngModelChange)="criteriaChanged()"
                               [options]="states">
                    </ws-select>
                </div>
            </div>
            <div class="d-flex filter-group align-items-center">
                <label class="ws-flex-auto my-0" for="form-type">Form Type:</label>
                <div class="ws-flex-auto">
                    <select class="form-select form-select-sm"
                            id="form-type"
                            name="formType"
                            [(ngModel)]="selectedFormType"
                            (ngModelChange)="criteriaChanged()">
                        <option [ngValue]="null">-- Select --</option>
                        @for (formType of formTypes; track formType) {
                            <option [ngValue]="formType">{{ formType.name }}</option>
                        }
                    </select>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column w-100 flex-grow-1">
            @if (formList) {
                <div class="form-manager-container ws-flex-auto d-flex flex-column">
                    @if (formList.length) {
                        <div class="form-list-holder">
                            <ul>
                                @for (form of formList; track form; let i = $index) {
                                    <li>
                                        <div [ngClass]="i % 2 ? 'tree-line-holder-odd' : 'tree-line-holder-even'">
                                            @if (!isExpanded(form)) {
                                                <span class="fa node-collapsed" (click)="expandForm(form)"></span>
                                            } @else {
                                                <span class="fa node-expanded" (click)="collapseForm(form)"></span>
                                            }
                                            <span>{{ form.name }}</span>
                                            @if (form.description) {
                                                <span class="text-muted small">{{ form.description }}</span>
                                            }
                                            @if (canEdit || canView) {
                                                <span class="button-group">
                                                    <button type="button"
                                                            (click)="editForm(form)"
                                                            class="ace-btn has-icon btn-primary btn-action"
                                                            title="Edit">
                                                        <i class="fa fa-pencil"></i>
                                                    </button>
                                                    @if (canEdit) {
                                                        <button type="button"
                                                                (click)="createRevision(form)"
                                                                class="ace-btn has-icon btn-secondary btn-action"
                                                                title="New Revision">
                                                            <i class="fa fa-plus"></i>
                                                        </button>
                                                    }
                                                    @if (canEdit) {
                                                        <button type="button"
                                                                (click)="deleteForm(form)"
                                                                class="ace-btn has-icon btn-primary btn-danger"
                                                                title="Delete">
                                                            <i class="fa fa-trash"></i>
                                                        </button>
                                                    }
                                                </span>
                                            }
                                        </div>
                                        @if (isExpanded(form)) {
                                            <ul>
                                                @for (revision of form.formRevisions; track revision; let j = $index) {
                                                    <li>
                                                        <div class="tree-line-level-2"
                                                             [ngClass]="(i + j + 1) % 2 ? 'tree-line-holder-odd' : 'tree-line-holder-even'">
                                                            @if (isRevisionCollapsed(revision)) {
                                                                <span class="fa node-collapsed"
                                                                      (click)="expandFormRevision(revision)"></span>
                                                            } @else {
                                                                <span class="fa node-expanded"
                                                                      [ngClass]="revision.supplementalForms.length > 0 ? '' : 'empty-tree-node'"
                                                                      (click)="collapseFormRevision(revision)"></span>
                                                            }
                                                            <span>
                                                                @if (revision.isFormConsolidated) {
                                                                    <i
                                                                        class="consolidated-icon fa fa-sitemap"
                                                                        helpTooltip
                                                                        helpContentId="form.is-form-consolidated">
                                                                    </i>
                                                                }
                                                                @if (revision.electronicFilingTypeId != null) {
                                                                    <i
                                                                        class="fa fa-cloud-arrow-up"
                                                                        helpTooltip
                                                                        helpContentId="form.electronic-filing-is-supported">
                                                                    </i>
                                                                }
                                                                {{ revision.name }}
                                                            </span>
                                                            @if (revision.description) {
                                                                <span class="text-muted small">{{ revision.description }}</span>
                                                            }
                                                            @if (revision.yearInfo) {
                                                                <span class="text-muted small"> {{ revision.yearInfo }}</span>
                                                            }
                                                            @if (revision.priorFormRevisionName) {
                                                                <span class="text-muted small">
                                                                    (Prior: {{ revision.priorFormRevisionName }})</span>
                                                            }
                                                            @if (canEdit || canView) {
                                                                <span class="button-group">
                                                                    <button type="button"
                                                                            (click)="configureAssociations(revision)"
                                                                            class="ace-btn has-icon btn-primary btn-action"
                                                                            title="Configure">
                                                                        <i class="fa fa-wrench"></i>
                                                                    </button>
                                                                    <button type="button"
                                                                            (click)="editRevision(form, revision)"
                                                                            class="ace-btn has-icon btn-secondary btn-action"
                                                                            title="Edit">
                                                                        <i class="fa fa-pencil"></i>
                                                                    </button>
                                                                    @if (canEdit) {
                                                                        <button type="button"
                                                                                (click)="createSupplement(form, revision)"
                                                                                class="ace-btn has-icon btn-secondary btn-action"
                                                                                title="New Supplemental">
                                                                            <i class="fa fa-plus"></i>
                                                                        </button>
                                                                    }
                                                                    @if (canEdit) {
                                                                        <button type="button"
                                                                                (click)="deleteRevision(revision)"
                                                                                class="ace-btn has-icon btn-primary btn-danger"
                                                                                title="Delete">
                                                                            <i class="fa fa-trash"></i>
                                                                        </button>
                                                                    }
                                                                </span>
                                                            }
                                                        </div>
                                                        @if (!isRevisionCollapsed(revision)) {
                                                            <ul>
                                                                @for (
                                                                    supplemental of revision.supplementalForms; track supplemental; let
                                                                    k = $index) {
                                                                    <li>
                                                                        <div class="tree-line-level-3"
                                                                             [ngClass]="(i + j + k + 2) % 2 ? 'tree-line-holder-odd' : 'tree-line-holder-even'">
                                                                            <span>
                                                                                @if (supplemental.electronicFilingTypeId != null) {
                                                                                    <i
                                                                                        class="fa fa-cloud-arrow-up"
                                                                                        helpTooltip
                                                                                        helpContentId="form.electronic-filing-is-supported">
                                                                                    </i>
                                                                                }
                                                                                {{ supplemental.name }}
                                                                            </span>
                                                                            @if (supplemental.description) {
                                                                                <span class="text-muted small">{{ supplemental.description }}</span>
                                                                            }
                                                                            @if (supplemental.yearInfo) {
                                                                                <span class="text-muted small"> {{ supplemental.yearInfo }}</span>
                                                                            }
                                                                            @if (supplemental.priorFormRevisionName) {
                                                                                <span class="text-muted small">
                                                                                    (Prior: {{ supplemental.priorFormRevisionName }})</span>
                                                                            }
                                                                            @if (canEdit || canView) {
                                                                                <span class="button-group">
                                                                                    <button type="button"
                                                                                            (click)="configureAssociations(supplemental)"
                                                                                            class="ace-btn has-icon"
                                                                                            title="Configure">
                                                                                        <i class="fa fa-wrench"></i>
                                                                                    </button>
                                                                                    <button type="button"
                                                                                            (click)="editSupplement(form, revision, supplemental)"
                                                                                            class="ace-btn has-icon"
                                                                                            title="Edit">
                                                                                        <i class="fa fa-pencil"></i>
                                                                                    </button>
                                                                                    @if (canEdit) {
                                                                                        <button type="button"
                                                                                                (click)="deleteSupplement(supplemental)"
                                                                                                class="ace-btn has-icon btn-primary btn-danger"
                                                                                                title="Delete">
                                                                                            <i class="fa fa-trash"></i>
                                                                                        </button>
                                                                                    }
                                                                                </span>
                                                                            }
                                                                        </div>
                                                                    </li>
                                                                }
                                                            </ul>
                                                        }
                                                    </li>
                                                }
                                            </ul>
                                        }
                                    </li>
                                }
                            </ul>
                        </div>
                    } @else {
                        <div class="d-flex w-100 h-100 ws-flex-justify-content-center align-items-center">
                            <div>No Forms to Show</div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>

